module.exports = __webpack_public_path__ + "img/logo.263d54c1.png";